export const BANNER_PAGE_SIZE = 20;

export const ALLOWED_ACTIVE_BANNERS = {
  banners_horizontal: 10,
  banners_popup: 1,
  banners_friday: 10,
};
